import * as Cart from '@shopify/theme-cart';

export async function swymLoaded() {
  return new Promise(resolve => {
    let swymLoadedChecker;
    function checker() {
      if (window._swat) {
        window.cancelAnimationFrame(swymLoadedChecker);
        swymLoadedChecker = undefined;
        resolve();
      } else {
        swymLoadedChecker = window.requestAnimationFrame(() => {
          checker();
        });
      }
    }

    checker();
  });
}

export const updateMiniCart = async () => {
  const cartItem = await Cart.getState();
  const cartItemCount = document.querySelector('#cart-item-count');
  cartItemCount.innerText = `(${cartItem.item_count})`;
};

export const addToCart = async function(element, variantId, quantity) {
  try {
    element.innerHTML = 'Adding to bag..';
    await Cart.addItem(variantId, { quantity: quantity });

    element.innerHTML = 'Added to Bag';

    updateMiniCart();
    setTimeout(() => {
      element.innerHTML = 'Add to Bag';
    }, 3000);
  } catch (e) {
    element.innerHTML = 'Add to Bag';
    console.error('Error adding item to cart.', e);
  }
};
